import fetch from "cross-fetch"

import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client"

export const ApolloClientRuntime = new ApolloClient({
  link: new HttpLink({
    uri:
      process.env.GATSBY_WP_GRAPHQL || `https://cms.borenius.com/wp/graphql/`,
    fetch,
  }),
  cache: new InMemoryCache(),
})
